module.exports = __webpack_public_path__ + "static/media/ellipsis-v.76d8706d.svg";